import React from "react";
import PaperSheet from "./PaperSheet";
import {Typography} from "@material-ui/core";
import {useCurrentState} from "../globalState";

function IndexPage() {
    let [_, setTitle] = useCurrentState("title");

    setTitle("Dashboard");
    return <div>
        <PaperSheet>
            <Typography variant={"body2"}>Mini dashboard here</Typography>
        </PaperSheet>
    </div>
}

export default IndexPage;